import React from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
// Chakra imports
import {
  Alert,
  AlertIcon,
  Box,
  Button,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
// Custom components
import DefaultAuth from "layouts/auth/Default";
// Assets
import illustration from "../../../assets/img/auth/auth.png";

import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiEyeCloseLine } from "react-icons/ri";
import { isAdminAuthenticated, setAdminSession } from "../../../utils/adminAuth";
const ENV_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";

const API_BASE = `${ENV_API_BASE_URL}/api`;

function SignIn() {
  const navigate = useNavigate();
  const location = useLocation();
  // Chakra color mode
  const textColor = useColorModeValue("#bd0005.700", "white");
  const textColorSecondary = "gray.400";
 
  const brandStars = useColorModeValue("brand.500", "brand.400");
  
  const [show, setShow] = React.useState(false);
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");
  const handleClick = () => setShow(!show);

  if (isAdminAuthenticated()) {
    return <Navigate to="/admin/default" replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const res = await axios.post(`${API_BASE}/auth/login`, { email, password });
      setAdminSession(res.data?.data);
      navigate(location.state?.from?.pathname || "/admin/default", { replace: true });
    } catch (err) {
      setError(err.response?.data?.message || "Failed to sign in.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <DefaultAuth illustrationBackground={illustration} image={illustration}>
      <Flex
        maxW={{ base: "100%", md: "max-content" }}
        w='100%'
        mx={{ base: "auto", lg: "0px" }}
        me='auto'
        h='100%'
        alignItems='start'
        justifyContent='center'
        mb={{ base: "30px", md: "60px" }}
        px={{ base: "25px", md: "0px" }}
        mt={{ base: "40px"}}
        flexDirection='column'>
          <Heading color='BLACK' fontSize='50px' mb='20px'>
            HATHA YOGASHRAM
          </Heading>
        <Box me='auto'>
           <Heading color='#bd0005' textAlign='center'  fontWeight='500' fontSize='30px' mb='60px'>
            Best Yoga Teacher Training in India
          </Heading>
          <Heading color='#090072' fontSize='40px' mb='40px' textAlign="center">
            Sign In
          </Heading>
        </Box>
        <Flex
          zIndex='2'
          direction='column'
          w={{ base: "100%", md: "420px" }}
          maxW='100%'
          background='transparent'
          borderRadius='15px'
          mx={{ base: "auto", lg: "unset" }}
          me='auto'
          mb={{ base: "20px", md: "auto" }}>
          <FormControl as="form" onSubmit={handleSubmit}>
            {error ? (
              <Alert status="error" mb="20px" borderRadius="12px">
                <AlertIcon />
                {error}
              </Alert>
            ) : null}
            <FormLabel
              display='flex'
              ms='4px'
              fontSize='20px'
              fontWeight='700'
              color={textColor}
              mb='8px'>
              UserName<Text color={brandStars}>*</Text>
            </FormLabel>
            <Input
              isRequired={true}
              variant='auth'
              fontSize='15px'
              color='#353333'
              ms={{ base: "0px", md: "0px" }}
              type='email'
              placeholder='Enter UserName'
              mb='24px'
              fontWeight='500'
              size='lg'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <FormLabel
              ms='4px'
            fontSize='20px'
              fontWeight='700'
              color={textColor}
              display='flex'>
              Password<Text color={brandStars}>*</Text>
            </FormLabel>
            <InputGroup size='md'>
              <Input
                isRequired={true}
                fontSize='15px'
                placeholder='Enter password'
                mb='24px'
                size='lg'
                color='#353333'
                type={show ? "text" : "password"}
                variant='auth'
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <InputRightElement display='flex' alignItems='center' mt='4px'>
                <Icon
                  color={textColorSecondary}
                  _hover={{ cursor: "pointer" }}
                  as={show ? RiEyeCloseLine : MdOutlineRemoveRedEye}
                  onClick={handleClick}
                />
              </InputRightElement>
            </InputGroup>
            <Flex justifyContent='space-between' align='center' mb='24px'>
              <FormControl display='flex' alignItems='center'>
                <Checkbox
                  id='remember-login'
                  colorScheme='brandScheme'
                  me='10px'
                />
                <FormLabel
                  htmlFor='remember-login'
                  mb='0'
                  fontWeight='normal'
                  color={textColor}
                  fontSize='sm'>
                  Keep me logged in
                </FormLabel>
              </FormControl>
              {/* <NavLink to='/auth/forgot-password'>
                <Text
                  color={textColorBrand}
                  fontSize='sm'
                  w='124px'
                  fontWeight='500'>
                  Forgot password?
                </Text>
              </NavLink> */}
            </Flex>
            <Button
              type="submit"
              fontSize='sm'
              variant='brand'
              fontWeight='500'
              w='100%'
              h='50'
              mb='24px'
              isLoading={loading}
              loadingText="Signing In">
              Sign In
            </Button>
          </FormControl>
        </Flex>
      </Flex>
    </DefaultAuth>
  );
}

export default SignIn;
